"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _require = require("styletron-engine-atomic"),
    Client = _require.Client,
    Server = _require.Server;

var memoizedValue;

module.exports = function () {
  return function (options) {
    if (!memoizedValue) {
      var instance;

      if (typeof window !== "undefined" && window.document.createElement) {
        var styleElements = document.getElementsByClassName("_styletron_hydrate_");
        instance = new Client((0, _extends2["default"])({
          hydrate: styleElements
        }, options));
      } else {
        instance = new Server(options);
      }

      memoizedValue = {
        instance: instance
      };
    }

    return memoizedValue;
  };
}();